import { axiosRequest } from '@/middlewares/axios'
import {conf} from '@/config/config'

export const consumptionCurveService = {
  update,
  updateConsumptionCurveFromEnedisApi,
  startImportWithEnedis,
  getEnedisImportProgress
}

async function update({ params } : { params:any }) {
  return await axiosRequest.postRequest(conf.API_URL + '/consumptionCurves/' + params.customerId, params.formData)
}

async function updateConsumptionCurveFromEnedisApi({ params } : { params:any }) {
  return await axiosRequest.postRequest(conf.API_URL + '/consumptionCurves/' + params.customerId, params.formData)
}

async function startImportWithEnedis(params) {
  return await axiosRequest.postRequest(conf.API_URL + '/enedis/load-curves', params)
}

async function getEnedisImportProgress(customerId) {
  return await axiosRequest.getRequest(conf.API_URL + '/enedis/load-curves/' + customerId)
}